import { MINIMUM_CUSTOMER_AGE } from '@flows/insurance/constants'

import { CONTENTS_NXT_CONSTANTS } from './constants'

const contentsText = {
  steps: {
    contents_confirm_location: {
      info: {
        text: {
          de: 'Falls diese Adresse nicht mehr deinem aktuellen Erstwohnsitz entspricht, kannst du diese im Profilbereich der Getsafe App ändern.',
          en: 'In case this address is not up to date with your primary residence anymore, you can change it under the profile section of the Getsafe App.',
        },
      },
    },
    contents_birthday: {
      title: {
        de: 'Bitte gib dein Geburtsdatum an.',
        en: 'Please enter your date of birth.',
      },
      errors: {
        errorTooYoung: {
          de: `Du musst mindestens ${MINIMUM_CUSTOMER_AGE.de} Jahre alt sein.`,
          en: `You must be at least ${MINIMUM_CUSTOMER_AGE.de} years old. `,
        },
        errorTooOld: {
          de: `Du darfst maximal ${CONTENTS_NXT_CONSTANTS.maxCustomerAge} Jahre alt sein.`,
          en: `You must be no more than  ${CONTENTS_NXT_CONSTANTS.maxCustomerAge} years old.`,
        },
      },
    },
    contents_living_space: {
      title: {
        de: 'Bitte gib die Größe deiner Wohnfläche an.',
        en: 'Please indicate the size of your living space.',
      },
      input: {
        label: {
          de: 'Wohnfläche (m²)',
          en: 'Living space (m²)',
        },
        error: {
          min: {
            de: `Die Größe deiner Wohnfläche muss mindestens ${CONTENTS_NXT_CONSTANTS.livingSpaceValidation.min} m² betragen.`,
            en: `The size of your living space must be at least ${CONTENTS_NXT_CONSTANTS.livingSpaceValidation.min} m².`,
          },
          max: {
            de: `Die Größe deiner Wohnfläche darf maximal ${CONTENTS_NXT_CONSTANTS.livingSpaceValidation.max} m² betragen.`,
            en: `The size of your living space cannot exceed ${CONTENTS_NXT_CONSTANTS.livingSpaceValidation.max} m².`,
          },
        },
      },
      infoBox: {
        text: {
          de: `Bitte beachte, dass wir Wohnungen ab ${CONTENTS_NXT_CONSTANTS.livingSpaceValidation.min} m² bis maximal ${CONTENTS_NXT_CONSTANTS.livingSpaceValidation.max} m² versichern. Die Wohnfläche findest du beispielsweise in deinem Mietvertrag. Auch, wenn du in einer WG wohnst, musst du die gesamte Fläche der Wohnung angeben. Übrigens: Du kannst deine Mitbewohner jederzeit einfach und kostenlos zu deinem Schutz hinzufügen.`,
          en: `Please note that we insure apartments from ${CONTENTS_NXT_CONSTANTS.livingSpaceValidation.min} m² to a maximum of ${CONTENTS_NXT_CONSTANTS.livingSpaceValidation.max} m². You can find the living space in your rental contract, for example. If you live in a flat share, you must also indicate the total area of the apartment. By the way: You can add your roommates to your coverage at any time, easily and free of charge.`,
        },
      },
    },
    contents_insured_amount: {
      input: {
        error: {
          min: {
            de: 'Deine Versicherungssumme muss mindestens 10.000 € betragen.',
            en: 'Your insured sum needs to be at least € 10,000.',
          },
          max: {
            de: 'Deine Versicherungssumme darf maximal 250.000 € betragen.',
            en: 'Your insured sum cannot exceed € 250,000.',
          },
        },
      },
      modalWarning: {
        title: {
          en: 'What does being underinsured mean?',
          de: 'Was bedeutet es, unterversichert zu sein?',
        },
        text1: {
          en: 'To calculate your personalised insured sum, we need to know the size of your home. Despite this, you know what’s in your home and how much it’s worth a lot better than we do. For this reason, we allow you to adapt your insured sum.',
          de: 'Für die Berechnung deiner persönlichen Versicherungssumme benötigen wir deine Wohnungsgröße. Trotzdem weißt du natürlich viel besser, was in deiner Wohnung steht und wie viel dein Hab und Gut wert ist. Aus diesem Grund, kannst du deine Versicherungssumme bei uns anpassen.',
        },
        text2: {
          en: 'In the event of a claim, we check that the value of your possessions corresponds to the amount you’re covered for. If you’re underinsured, we will only pay a portion of the costs.',
          de: 'Im Schadenfall überprüfen wir, ob der Wert deiner persönlichen Gegenstände deiner gewählten Versicherungssumme entspricht. Wenn du unterversichert bist, übernehmen wir im Schadenfall nur anteilig die Kosten.',
        },
        text3: {
          en: 'Example: We calculate an insured sum of €50,000 for you, based on the size of your home. However, you believe that this amount is too high and that you only need €25,000 of coverage. When it comes to filing a claim and you make one for €5,000, we’ll only pay €2,500. Why? Because you have only insured 50% of what you should have and, therefore, only receive 50% of your claim.',
          de: 'Beispiel: Anhand deiner Wohnungsgröße haben wir eine Versicherungssumme von 50.000 € für dich berechnet. Du bist jedoch der Meinung, das diese Kalkulation nicht für deinen Hausrat aufgeht und vereinbarst eine Versicherungssumme von 25.000 €. Nun kommt es zu einem Hausratschaden in Höhe von 5.000 €. Dir werden jedoch nur 2.500 € ausbezahlt. Warum? Da du nur 50 % des tatsächlichen Wertes versichert hast, bekommst du auch nur 50 % des Schadens ausbezahlt.',
        },
        text4: {
          en: 'We recommend that you insure yourself for at least €650 per square metre in your home. The calculation would look like this: 100m2 x €650 = an insured sum of €65,000. If you opt for €650 per m2, our underinsurance waiver applies. This means that we will not reduce your payout in the event of a claim, and we will cover you up to your agreed insured sum.',
          de: 'Daher empfehlen wir: Wähle pro Quadratmeter mindestens 650 € als Versicherungssumme. Die Berechnung sieht beispielsweise so aus: 100 m2 x 650 € = 65.000 (Versicherungssumme). Wenn du pro Quadratmeter Wohnfläche mindestens 650 € als Versicherungssumme wählst, haben wir einen Unterversicherungsverzicht vereinbart. Das bedeutet, dass wir den Schaden nicht kürzen und im Schadenfall die Kosten bis zur vereinbarten Versicherungssumme übernehmen.',
        },
      },
      title: {
        de: 'Bitte wähle deine Versicherungssumme',
        en: 'Please choose your insured sum amount',
      },
      infobox: {
        terms: {
          title: {
            en: 'Insured sum',
            de: 'Versicherungssumme',
          },
          text1: {
            de: 'Die Versicherungssumme ist der maximale Wert, den wir dir im Falle eines Schadens auszahlen. Der Wert sollte dem Neuwert aller Dinge entsprechen, die du in deinem Zuhause besitzt.',
            en: 'The insured sum is the maximum value we pay in case of a damage. It should reflect the replacement value of all items you own.',
          },
          text2: {
            de: 'Wir empfehlen einen Wert von mindestens 650 € pro Quadratmeter. Du kannst den Wert anpassen, allerdings könntest du unterversichert sein, wenn du einen Wert unter unserer Empfehlung wählst.',
            en: 'We set it to our recommendation based on the size of your residence. You can adapt it, but you might be underinsured if you set it below what we recommend.',
          },
        },
      },
    },
    contents_permanent_residence: {
      title: {
        de: 'Handelt es sich bei der Wohnung/dem Haus um deinen Hauptwohnsitz?',
        en: 'Is this home your primary place of residence?',
      },
    },
    contents_insurance_owned: {
      title: {
        de: 'Hattest du innerhalb der letzten 5 Jahre eine Hausratversicherung?',
        en: 'Did you have a contents insurance within the last 5 years?',
      },
    },
    contents_damages: {
      title: {
        de: 'Wie viele Hausratschäden hattest du in den letzten 5 Jahren?',
        en: 'How many contents claims did you file for within the last 5 years?',
      },
    },
    contents_insurance_cancelled: {
      title: {
        de: 'Hattest du in den letzten fünf Jahren eine Hausratversicherung, die durch den Versicherer gekündigt wurde?',
        en: 'Have you had a contents insurance policy with another company within the last five years that was cancelled by the insurance company?',
      },
    },
    contents_deductibles: {
      title: {
        de: 'Bitte wähle die Höhe deiner Selbstbeteiligung.',
        en: 'Please choose the amount of your excess.',
      },
      options: {
        0: {
          en: '€0',
          de: '0 €',
        },
        250: {
          en: '€250',
          de: '250 €',
        },
        500: {
          en: '€500',
          de: '500 €',
        },
      },
    },
    contents_glass: {
      title: {
        de: 'Möchtest du die Erweiterung Glas hinzufügen?',
        en: 'Do you want to add the glass extension?',
      },
      infoBox: {
        text: {
          de: 'Spiegel, verglaste Möbel, Aquarien, dein Ceran Kochfeld... sind im Basisschutz nicht versichert. Mit dem Upgrade Glas springen wir ein, wenn diese durch Glasbruch beschädigt werden.',
          en: 'Mirrors, glazed furniture, aquariums, your ceran hob... are not covered by the basic protection. With the upgrade glass, we step in if they are damaged due to glass breakage.',
        },
      },
    },
    contents_bike: {
      title: {
        de: 'Möchtest du die Erweiterung Fahrrad hinzufügen?',
        en: 'Do you want to add the bike extension?',
      },
      infoBox: {
        text: {
          de: 'Damit versicherst du dein Fahrrad (auch E-Bike, Carbonfahrrad, Pedelec, ...) gegen Diebstahl.',
          en: 'This covers your bike (also e-bike, carbon bike, pedelec, ...) against theft.',
        },
      },
    },
    contents_bike_insured_sum: {
      title: {
        de: 'Bitte gib die Versicherungssumme an. Diese entspricht dem Kaufpreis deines Fahrrads laut Rechnung.',
        en: 'Please indicate the sum insured. This corresponds to the purchase price of your bicycle according to the invoice.',
      },
      input: {
        de: 'Versicherungssumme',
        en: 'Purchase price',
      },
      confirmation: {
        de: 'Möchtest die Erweiterung Fahrrad für die angegebene Versicherungssumme hinzufügen?',
        en: 'Would you like to add the bike extension for the specified sum insured?',
      },
      infoBox: {
        text: {
          de: 'Du kannst auch mehrere Fahrräder absichern. In diesem Fall musst du den Kaufpreis aller Fahrräder zusammengerechnet angeben. Bitte beachte, dass die Versicherungssumme zwischen 500 € und 5.000 € liegen muss. Eine geringere Versicherungssumme wird automatisch auf 500 € gesetzt, eine höhere auf 5.000 €.',
          en: 'You can also cover several bikes. In this case you have to declare the purchase price of all bikes together. Please note that the insured sum must be between € 500 and € 5,000. A lower sum insured is automatically set to € 500, a higher one to € 5,000.',
        },
      },
      errors: {
        insured_sum: {
          de: 'Die Versicherungssumme wurde automatisch angepasst, da sie zu niedrig oder zu hoch war.',
          en: 'The sum insured was automatically adapted as it was too high or too low.',
        },
        minimum: {
          en: 'The insured sum must be at least €500',
          de: 'Die Versicherungssumme muss mindestens 500 € betragen',
        },
        maximum: {
          en: "The insured sum shouldn't exceed €5,000€",
          de: 'Die Versicherungssumme darf nicht höher als 5000 € sein',
        },
      },
    },
    contents_location: {
      title: {
        de: 'Wo wohnst du?',
        en: 'Where do you live?',
      },
    },
    contents_insurance_choice: {
      title: {
        de: 'Möchtest du eine Hausratversicherung abschließen?',
        en: 'Would you like to take out contents insurance?',
      },
      subtitle: {
        de: 'Diese kommt für Schäden an deinen Habseligkeiten auf, die in deiner (Miet- oder Eigentums-)Wohnung durch z. B. Sturm, Wasser oder Feuer entstehen. Auch bei Einbruchdiebstahl springt die Hausratversicherung ein.',
        en: 'This insurance covers damage to your belongings caused by storms, water or fire in your (rented or owned) apartment. The contents insurance also covers burglary.',
      },
    },
    contents_natural_disasters: {
      title: {
        de: 'Möchtest du die Erweiterung Elementarschäden ab 0,31€ hinzufügen?',
        en: 'Do you want to add the extension natural disasters starting from 0,31€?',
      },
      infoBox: {
        text: {
          de: 'Die Erweiterung für Naturkatastrophen deckt Schäden ab, die durch Naturgewalten verursacht werden. Dazu gehören Risiken wie Überschwemmungen, Erdbeben, Lawinen, Schneedruck, Vulkanausbrüche und mehr.',
          en: 'The extension for natural disasters covers damage caused by forces of nature. These include risks such as floods, earthquakes, avalanches, snow pressure, volcanic eruptions and more.',
        },
        text2: {
          de: 'Dabei besteht ein Selbstbehalt von 10% (min. 500€, max. 5.000€) sowie eine Wartezeit von 14 Tagen.',
          en: 'A deductible of 10% (min. €500, max. €5,000) as well as a waiting time of 14 days will apply.',
        },
      },
    },
    wg_insured: {
      title: {
        de: 'Für WGs: Möchtest du deine Mitbewohner zu deinem Schutz hinzufügen?',
        en: 'If your insured home is a shared flat, you can add your flatmates to your coverage. Would you like to do this now?',
      },
      infoBox: {
        text: {
          de: 'Die gemeinsame Wohnung mit deinem Partner / deiner Partnerin fällt nicht unter den WG-Begriff. Du kannst den Namen deines Partners bzw. deiner Partnerin später in der App kostenlos zu deinem Schutz hinzufügen.',
          en: "The shared apartment with your partner is not covered by the term WG. You can add your partner's name to your coverage in the app, completely free of charge.",
        },
      },
    },
    wg_members: {
      title: {
        de: 'Mit wem wohnst du zusammen?',
        en: 'Who do you live with?',
      },
      text: {
        de: 'Du kannst bis zu 5 Personen hinzufügen',
        en: 'You can add up to 5 flatmates',
      },
      input: {
        de: 'Person',
        en: 'Flatmate',
      },
    },
    quote: {
      subtitle: {
        de: 'Basierend auf {{living_space_square_meters}} m² Wohnfläche in {{zip_code}}',
        en: 'Based on a home size of {{living_space_square_meters}}m² at {{zip_code}}',
      },
    },
  },
}
export default contentsText
